import { SupHeading, SupText } from "@repo/core-ui";
import React from "react";
import { twMerge } from "tailwind-merge";

interface SectionHeadingsProps {
  heading?: React.ReactNode;
  subheading?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

export default function SectionHeadings({ heading, subheading, className, children }: SectionHeadingsProps) {
  return (
    <div className={twMerge("space-y-2 py-2 pb-8", className)}>
      <SupHeading className="text-neutral-950" as="h2" family="mono" variant="h5" weight="bold">
        {heading}
      </SupHeading>
      <SupText as="div" className="text-neutral-900" family="mono" variant="subtitle2" weight="regular">
        {subheading}
      </SupText>
      {children}
    </div>
  );
}
